
  import { createApiClient } from 'Network/ApiClient';
  
  export const IcdErrorAxiosInstance = createApiClient('relationdiagnoses/');


